/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 60% GC region melts at a higher temperature than a 40% GC region of the same length.`)
};

const es_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una región con 60% de GC funde a una temperatura más alta que una región con 40% de GC de la misma longitud.`)
};

const de_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Region mit 60% GC-Gehalt schmilzt bei einer höheren Temperatur als eine Region mit 40% GC-Gehalt gleicher Länge.`)
};

const nl_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een regio met 60% GC smelt bij een hogere temperatuur dan een regio met 40% GC van dezelfde lengte.`)
};

const fr_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une région à 60 % GC fond à une température plus élevée qu'une région à 40 % GC de même longueur.`)
};

const it_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una regione con GC al 60% fonde a una temperatura più alta di una regione con GC al 40% della stessa lunghezza.`)
};

const pt_br2_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma região com 60% de GC funde em uma temperatura mais alta que uma região com 40% de GC do mesmo comprimento.`)
};

const pt_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma região com 60% de GC funde a uma temperatura mais alta do que uma região com 40% de GC do mesmo comprimento.`)
};

const ja_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC60%の領域は、同じ長さのGC40%の領域よりも高い温度で融解します。`)
};

const zh_gc_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC 含量 60% 的区域比长度相同、GC 含量 40% 的区域解链温度更高。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_ex3", locale)
	if (locale === "en") return en_gc_ex3(inputs)
	if (locale === "es") return es_gc_ex3(inputs)
	if (locale === "de") return de_gc_ex3(inputs)
	if (locale === "nl") return nl_gc_ex3(inputs)
	if (locale === "fr") return fr_gc_ex3(inputs)
	if (locale === "it") return it_gc_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_gc_ex3(inputs)
	if (locale === "pt") return pt_gc_ex3(inputs)
	if (locale === "ja") return ja_gc_ex3(inputs)
	return zh_gc_ex3(inputs)
};